// extracted by mini-css-extract-plugin
export var headerCell = "_1g-1";
export var loadingStateCell = "_1g-4";
export var rowWrapper = "_1g-3";
export var standaloneTable = "_1g-5";
export var table = "_1g-0";
export var white = "_1g-2";